import Vue from 'vue';
import router from '../router';

export default {
    state:{
      opcion_activa:'Dashboard',
      cliente:{nombre:''},
      test:{pruebas:[]},
      empleado:{nombre:''},
    },
    mutations: {
      setOpcionActiva(state,opcion_activa){
        state.opcion_activa=opcion_activa;
      }
    },
    actions: {
      ActualizarOpcionActiva(context,opcion_activa){
        context.commit('setOpcionActiva',opcion_activa);
      }
    },
    getters: {  
      getOpcionActiva(state){
        return state.opcion_activa;
      }
    },
    
}


// WEBPACK FOOTER //
// ./src/modules/menu.js